import { useContext } from 'react';

import {
  LegalClientEntity,
  LegalClientHeadEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import {
  OnboardingContext,
  OnboardingContextProps,
} from 'modules/onboarding/common/providers/OnboardingProvider/Context';

export const useOnboardingContext = () => {
  const res = useContext(OnboardingContext);
  return res as OnboardingContextProps<{
    currentClient: LegalClientRepresentativeEntity;
    legalClient: LegalClientEntity;
    legalClientHead: LegalClientHeadEntity;
    onCreateHead: (id: string) => void;
  }>;
};
